import { render } from "./camera.vue?vue&type=template&id=31274e40&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"

import "./camera.vue?vue&type=style&index=0&id=31274e40&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31274e40"]])

export default __exports__